import React, { Component } from 'react'
import Translations from '../../../TranslationsWrapper'

import * as LocationActions from '../../actions/LocationActions'

class ResultDetail extends Component {
  constructor(props) {
    super(props)

    // Bind events
    this.closeDetails = this.closeDetails.bind(this)

    // Generate route url
    this.routeUrl =
      '//maps.google.nl/maps?daddr=' +
      props.selectedSearchResult.Address +
      ' ' +
      props.selectedSearchResult.ZipCode +
      ' ' +
      this.props.selectedSearchResult.City
  }

  closeDetails() {
    LocationActions.setSelectedSearchResult(null)
  }

  render() {
    return (
      <div>
        <button className="c-location-finder__back" onClick={this.closeDetails}>
          <span className="c-location-finder__back__icon">
            <i className="u-icon--arrow-left" />
          </span>
          {this.props.translations.Results.Item.Back}
        </button>
        <div className="c-location-finder__detail">
          <h2>{this.props.selectedSearchResult.Name}</h2>
          {this.props.selectedSearchResult.Distance && (
            <p>
              {this.props.selectedSearchResult.Distance.toFixed(1)
                .toString()
                .replace('.', ',')}{' '}
              {this.props.translations.Results.Item.DistanceUnit}
            </p>
          )}

          <dl className="u-mb">
            <dt>
              <i className="u-icon-pin" />
            </dt>
            <dd>
              {this.props.selectedSearchResult.Address} <br />
              {this.props.selectedSearchResult.ZipCode}{' '}
              {this.props.selectedSearchResult.City}
            </dd>

            {this.props.selectedSearchResult.Telephone && (
              <>
                <dt>
                  <i className="u-icon-telephone" />
                </dt>
                <dd>{this.props.selectedSearchResult.Telephone}</dd>
              </>
            )}
            {this.props.selectedSearchResult.Email && (
              <>
                <dt>
                  <i className="u-icon-mail" />
                </dt>
                <dd>
                  <a href={'mailto:' + this.props.selectedSearchResult.Email}>
                    {this.props.selectedSearchResult.Email}
                  </a>
                </dd>
              </>
            )}
            {this.props.selectedSearchResult.Website && (
              <>
                <dt>
                  <i className="u-icon-language" />
                </dt>
                <dd>
                  <a
                    target="_blank"
                    href={this.props.selectedSearchResult.Website}
                  >
                    {this.props.selectedSearchResult.Website}
                  </a>
                </dd>
              </>
            )}
          </dl>

          <a href={this.routeUrl} target="_blank">
            {this.props.translations.Results.Item.Route}
          </a>
        </div>
      </div>
    )
  }
}

export default Translations('js-location-finder')(ResultDetail)
